export var SBER_ENDPOINTS = {
  sberRequestInfo: '/api/sberpay/content/',
  sberBinding: '/api/sberpay/binding/',
  sberStatus: '/api/sberpay/payment/status/',
  payment: '/api/sberpay/payment/'
};
export var FPS_ENDPOINTS = {
  fpsRequestInfo: '/sbpapi/',
  fpsBinding: '/sbpapi/binding/',
  postPaymentData: '/sbpapi/payment/',
  paymentStatus: '/sbpapi/payment-status/',
  psOperationDetails: '/sbpapi/lastPsOperation/',
  bankList: '/api/v1/payment/nspk/bankslist/'
};
export var CTN_STATUS = '/api/CtnStatus/Get/';
export var GOOGLE_PAY_ENDPOINTS = {
  transactionInfo: '/googlepay/gettransactioninfo',
  paymentConfig: '/googlepay/GetPaymentInfo/'
};
export var LINKED_CARDS_ENDPOINTS = {
  bankCards: '/api/v1/payment/bankCards'
};
export var IS_DEV = process.env.NODE_ENV === 'development';
export var IS_TEST = function IS_TEST() {
  return /beelinetst/.test(window.location.origin);
};
export var getPayApiHost = function getPayApiHost() {
  if (IS_DEV) {
    return '';
  }
  if (IS_TEST()) {
    return 'https://pay.webtest.vimpelcom.ru';
  }
  return 'https://widgetpay1.beeline.ru';
};